const AmenityCards = ({ rows = [] }) => {
  return (
    <div className="card-table-container flex flex-col gap-[15px]">
      {rows.length === 0 ? (
        <p className="info-text text-center">No amenity bookings found</p>
      ) : (
        rows.map((row, idx) => (
          <div key={row._id || idx} className="border border-gray-300 rounded-lg p-6 w-full">
            <div className="detail-row mb-2">
              <div className="detail-column">
                <p className="detail-label">Amenity</p>
                <p className="detail">{row.amenity?.name || 'N/A' || 'N/A'}</p>
              </div>
              <div className="detail-column">
              <p className="detail-label">Date</p>
              <p className="detail">
                {new Date(row.bookingDate).toLocaleDateString()}
              </p>
            </div>
            </div>
            <div className="detail-column mb-5">
                <p className="detail-label">Status</p>
                <span className={`request-status-badge ${row.status?.toLowerCase()}`} style={{ display: 'flex', justifyContent: 'center' }}>
                  {row.status}
                </span>
              </div>

            <div className="detail-row">
              <div className="detail-column">
                <p className="detail-label">From</p>
                <p className="detail">
                  {row.startTime}
                </p>
              </div>
              <div className="detail-column">
                <p className="detail-label">To</p>
                <p className="detail">
                  {row.endTime}
                </p>
              </div>
            </div>
            <div className="detail-column mb-2">
              <p className="detail-label">Notes</p>
              <p className="detail">{row.notes || 'N/A'}</p>
            </div>
          </div>
        ))
      )}
    </div>
  );
};

export default AmenityCards;
